<template>
  <div class="header-container flex justify-center">
    <div class="container">
      <div class="brand">
        <a href="/"><img src="../assets/logo2.png" class="logo"/></a>
        <span class="slogan">公益环境<br>数据中心</span>
      </div>
      <div class="search"></div>
      <el-menu :default-active="activeIndex" mode="horizontal" style="border-bottom: unset">
        <el-menu-item v-for="menu in menusCast" :key="menu.name" :index="menu.name" class="el-menu-item"><a :href="menu.href" target="_blank">{{ menu.text }}</a></el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: null
    },
    hideCurrent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menus: [
        { text: '首页', href: '/', name: 'index' },
        { text: '地图', href: '/map', name: 'map' },
        { text: '检索数据', href: '/search', name: 'search' },
        { text: '数据开放', href: '/pages/dataOpen.html', name: 'data-open' },
        { text: '研究报告', href: '/pages/noteList.html?c_id=1', name: 'report' },
        { text: '环评数据分析', href: 'http://eia.lvwang.org.cn/', name: 'eia' },
        { text: '关于我们', href: '/pages/aboutIndex.html', name: 'about' }
      ]
    }
  },
  computed: {
    menusCast() {
      return this.menus.filter(menu => {
        return !this.hideCurrent || menu.name !== this.activeIndex
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  z-index: 1;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E6E6E6;
  overflow-y: hidden;
}
.container {
  width: 1200px;
  display: flex;
  justify-content: stretch;
  align-items: center;
  height: 100%;
  font-size: 16px;
  position: relative;
}

.container a {
  text-decoration: none;
}

.container .brand,
.container .search {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* Brand */
.container .brand {
  margin-left: 30px;
}
.container .brand .slogan {
  margin-left: 10px;
  font-size: 14px;
  color: #005BAC;
}

/* Search */
.container .search {
  flex-grow: 1;
  margin-left: 20px;
}

.container .search .el-autocomplete .el-input__inner,
.container .search .el-autocomplete .el-input-group__append {
  border-radius: 0;
}

.container .search .el-autocomplete .el-input__inner,
.container .search .el-autocomplete .el-button {
  height: 25px;
  font-size: 12px;
}

.container .el-menu-item a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue